import {
  CaseStudyAttachmentDto,
  CaseStudyDraftFromFileDto,
  CaseStudyDto,
  CreateCaseStudyDto,
  UpdateCaseStudyDto,
} from '@paladin-monorepo/common';
import API from '../api';

export const caseStudiesApi = {
  async getCaseStudies(): Promise<CaseStudyDto[]> {
    return API.get<CaseStudyDto[]>('/case-studies').then((res) => res.data);
  },

  async createCaseStudy(dto: CreateCaseStudyDto): Promise<CaseStudyDto> {
    return API.post<CaseStudyDto>('/case-studies', dto).then((res) => res.data);
  },

  async draftFromFile(file: File): Promise<CaseStudyDraftFromFileDto> {
    const formData = new FormData();
    formData.append('file', file);
    return API.post<CaseStudyDraftFromFileDto>('/case-studies/draft-from-file', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((res) => res.data);
  },

  async getCaseStudyById(id: string): Promise<CaseStudyDto> {
    return API.get<CaseStudyDto>(`/case-studies/${encodeURIComponent(id)}`).then((res) => res.data);
  },

  async updateCaseStudy(id: string, dto: UpdateCaseStudyDto): Promise<CaseStudyDto> {
    return API.patch<CaseStudyDto>(`/case-studies/${encodeURIComponent(id)}`, dto).then((res) => res.data);
  },

  async deleteCaseStudy(id: string): Promise<void> {
    return API.delete<void>(`/case-studies/${encodeURIComponent(id)}`).then((res) => res.data);
  },

  async reorder(caseStudyIds: string[]): Promise<CaseStudyDto[]> {
    return API.patch<CaseStudyDto[]>('/case-studies/reorder', { caseStudyIds }).then(
      (res) => res.data,
    );
  },

  async replaceAttachment(
    caseStudyId: string,
    attachmentId: string,
    file: File,
  ): Promise<CaseStudyAttachmentDto> {
    const formData = new FormData();
    formData.append('file', file);
    return API.post<CaseStudyAttachmentDto>(
      `/case-studies/${encodeURIComponent(caseStudyId)}/attachments/${encodeURIComponent(attachmentId)}/file`,
      formData,
    ).then((res) => res.data);
  },

  async uploadAttachment(
    caseStudyId: string,
    file: File,
    description?: string,
  ): Promise<CaseStudyAttachmentDto> {
    const formData = new FormData();
    formData.append('file', file);
    if (description) {
      formData.append('description', description);
    }
    return API.post<CaseStudyAttachmentDto>(
      `/case-studies/${encodeURIComponent(caseStudyId)}/attachments`,
      formData,
    ).then((res) => res.data);
  },

  async deleteAttachment(caseStudyId: string, attachmentId: string): Promise<void> {
    return API.delete<void>(
      `/case-studies/${encodeURIComponent(caseStudyId)}/attachments/${encodeURIComponent(attachmentId)}`,
    ).then((res) => res.data);
  },

  async downloadAttachment(
    caseStudyId: string,
    attachmentId: string,
    filename: string,
  ): Promise<void> {
    const response = await API.get(
      `/case-studies/${encodeURIComponent(caseStudyId)}/attachments/${encodeURIComponent(attachmentId)}`,
      { responseType: 'blob' },
    );
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },
};
